// TODO: Update pending date formats
import {DayOfWeek, ServiceRegion} from '../../../common/constants';

/**
 | Format                   | USA                      | UK                      |
 | -------------------------| -------------------------| ------------------------|
 | shortDate                | MM/DD                    | DD/MM                   |
 | standardDate             | MM/DD/YY                 | DD/MM/YY                |
 | standardDayDate          | ddd MM/DD/YY             | ddd DD/MM/YY            |
 | standardDayMonthDate     | ddd MM/DD                | ddd DD/MM               |
 | fullDayDate              | ddd - MMM DD, YYYY       | ddd - MMM DD, YYYY      |
 | fullDate                 | MM/DD/YYYY               | DD/MM/YYYY              |
 | fullDateWithDash         | MM-DD-YYYY               | DD-MM-YYYY              |
 | standardTimestamp        | MM/DD/YY hh:mm A         | DD/MM/YY hh:mm A        |
 | standardTimestampAt      | MM/DD/YY @ HH:mm         | DD/MM/YY @ HH:mm        |
 | fullTimestamp            | MM/DD/YYYY - hh:mma      | DD/MM/YYYY - hh:mma     |
 | fullTimestampAt          | MM/DD/YYYY @ HH:mm       | DD/MM/YYYY @ HH:mm      |
 | timeFirstFullTimestamp   | HH:mm - MM/DD/YYYY       | HH:mm - DD/MM/YYYY      |
 | -------------------------|--------------------------|-------------------------|
 */
export enum DateFormatType {
  shortDate = 'shortDate',
  standardDate = 'standardDate',
  standardDayDate = 'standardDayDate',
  standardDayMonthDate = 'standardDayMonthDate',
  fullDayDate = 'fullDayDate',
  fullDate = 'fullDate',
  fullDateWithDash = 'fullDateWithDash',
  standardTimestamp = 'standardTimestamp',
  standardTimestampAt = 'standardTimestampAt',
  fullTimestamp = 'fullTimestamp',
  fullTimestampAt = 'fullTimestampAt',
  timeFirstFullTimestamp = 'timeFirstFullTimestamp',
  shortMonthDate = 'shortMonthDate',
  shortMonthYear = 'shortMonthYear',
  abbMonthTimeStamp = 'abbMonthTimeStamp'
}
export type DateFormats = {
  [key in DateFormatType]: string;
};
export interface RegionInfo {
  region: ServiceRegion;
  locale: string;
  dateFormats: DateFormats;
  weekStartsOn: DayOfWeek;
  weekEndingDay: DayOfWeek;
}
export type Region = { [key in ServiceRegion]: RegionInfo };
